// Module
var code = "<div class=\"mishion_history\"> <div class=\"mission_title\">Notes</div> </div> <div class=\"col-xs-12\"> <div class=\"col-xs-12\" ng-if=\"notesController.contract.Notes\"> {{notesController.contract.Notes}} </div> <div class=\"col-xs-12\" ng-if=\"!notesController.contract.Notes\">None</div> </div> ";
// Exports
export default code;